module.exports = __webpack_public_path__ + "img/freefooter-tw.c51a16c7.png";